/**
 * Redux-enabled view for the New User page (new 'choose password' flow)
 */
import React, { FunctionComponent } from 'react';
import PureUsernameRevealView from './username-reveal-view';
import { useDispatch, useSelector } from 'react-redux';
import { getNewUserState } from 'phoenix2/state/new-user/selectors';
import { finishViewingUsername } from 'phoenix2/state/new-user/actions';

export const UsernameRevealView: FunctionComponent = () => {
    const newUserState = useSelector(getNewUserState);
    const dispatch = useDispatch();

    return (
        <PureUsernameRevealView
            userName={newUserState.get('username')}
            onSubmit={() => dispatch(finishViewingUsername())}
        />
    );
};
